<div class="notification" (click)="showPopover()">
  <button #originRef [class.active]="dropdownOpen" class="button" mat-icon-button type="button">
    <net-iconify-icon style="z-index:-1" [icon]="icNotificationsActive" color="#5c78fd"></net-iconify-icon>
  </button>
  <span class="badge" [class.badgePosition]="notificationCount > 9" style="cursor: pointer;">{{ notificationCount === 0
    ? '' : notificationCount }}</span>
</div>